import { format, parseISO } from 'date-fns'

/** Celda de la fecha en que se completó una tarea, o un guion si no está completada. */
export function FechaCompletada({ fecha }: { fecha: string | null | undefined }) {
  if (!fecha) return <span className="text-muted-foreground">—</span>
  return <span className="whitespace-nowrap">{format(parseISO(fecha), 'dd/MM/yyyy')}</span>
}
